module.exports = __webpack_public_path__ + "img/hdcardlogo.fa8e62da.jpg";